import { __extends } from "tslib";
import { FreeCamera } from "./freeCamera";
import { Vector3 } from "../Maths/math.vector";
import { Node } from "../node";
import "./Inputs/freeCameraVirtualJoystickInput";
Node.AddNodeConstructor("VirtualJoysticksCamera", function (name, scene) {
    return function () { return new VirtualJoysticksCamera(name, Vector3.Zero(), scene); };
});
/**
 * This represents a free type of camera. It can be useful in First Person Shooter game for instance.
 * It is identical to the Free Camera and simply adds by default a virtual joystick.
 * Virtual Joysticks are on-screen 2D graphics that are used to control the camera or other scene items.
 * @see https://doc.babylonjs.com/features/cameras#virtual-joysticks-camera
 */
var VirtualJoysticksCamera = /** @class */ (function (_super) {
    __extends(VirtualJoysticksCamera, _super);
    /**
     * Intantiates a VirtualJoysticksCamera. It can be useful in First Person Shooter game for instance.
     * It is identical to the Free Camera and simply adds by default a virtual joystick.
     * Virtual Joysticks are on-screen 2D graphics that are used to control the camera or other scene items.
     * @see https://doc.babylonjs.com/features/cameras#virtual-joysticks-camera
     * @param name Define the name of the camera in the scene
     * @param position Define the start position of the camera in the scene
     * @param scene Define the scene the camera belongs to
     */
    function VirtualJoysticksCamera(name, position, scene) {
        var _this = _super.call(this, name, position, scene) || this;
        _this.inputs.addVirtualJoystick();
        return _this;
    }
    /**
     * Gets the current object class name.
     * @return the class name
     */
    VirtualJoysticksCamera.prototype.getClassName = function () {
        return "VirtualJoysticksCamera";
    };
    return VirtualJoysticksCamera;
}(FreeCamera));
export { VirtualJoysticksCamera };
//# sourceMappingURL=virtualJoysticksCamera.js.map